/* Generated by restful-react */

import React from 'react'
import {
  Get,
  GetProps,
  useGet,
  UseGetProps,
  Mutate,
  MutateProps,
  useMutate,
  UseMutateProps,
  Poll,
  PollProps,
} from 'restful-react'

export const SPEC_VERSION = 'v9'
export interface RequestForProposal {
  id: number
  shipmentId?: number
  shipmentIssueTypeId?: number
  shipmentIssueReasonId?: number
  shipmentIssueFaultId?: number
  createdAt: string
  title: string
  status?: string | null
  googleSheetsUrl: string
  createdByUser: CreatedByUser
  shipperApplication: ShipperApplication
  salesforceRfpId: string
  salesforceRfpTitle: string | null
  rfpType: string
  auditWorkspace: boolean
}

export interface CreatedByUser {
  id?: number | null
  firstName?: string | null
  lastName?: string | null
}

export interface ShipperApplication {
  id: number
  name: string
}

export interface RequestForProposalFilters {
  salesforceRfpTitle?: string
  salesforceRfpId?: string
  shipperApplicationId?: number
  googleSheetsUrl?: string
  currentUser?: boolean
  userId?: number
  id?: number
  statuses?: string[]
  rfpTypes?: string[]
}

export interface RequestForProposalsResponse {
  requestForProposals: RequestForProposal[]
  totalCount: number
}

export interface ClientError {
  errors?: string[]
}

export interface GetRequestForProposalsQueryParams {
  /**
   * Filters
   */
  filters?: RequestForProposalFilters
  /**
   * Page Count
   */
  pageCount?: number
  /**
   * Per Page Size
   */
  pageSize?: number
  /**
   * Sort Order
   */
  sortOrder?: string
  /**
   * Sort Field
   */
  sortField?: string
}

export type GetRequestForProposalsProps = Omit<
  GetProps<RequestForProposalsResponse, unknown, GetRequestForProposalsQueryParams, void>,
  'path'
>

/**
 * Gets all request for proposals
 */
export const GetRequestForProposals = (props: GetRequestForProposalsProps) => (
  <Get<RequestForProposalsResponse, unknown, GetRequestForProposalsQueryParams, void>
    path='/v9/request_for_proposals'
    {...props}
  />
)

export type PollGetRequestForProposalsProps = Omit<
  PollProps<RequestForProposalsResponse, unknown, GetRequestForProposalsQueryParams, void>,
  'path'
>

// Gets all request for proposals (long polling)
export const PollGetRequestForProposals = (props: PollGetRequestForProposalsProps) => (
  <Poll<RequestForProposalsResponse, unknown, GetRequestForProposalsQueryParams, void>
    path='/v9/request_for_proposals'
    {...props}
  />
)

export type UseGetRequestForProposalsProps = Omit<
  UseGetProps<RequestForProposalsResponse, unknown, GetRequestForProposalsQueryParams, void>,
  'path'
>

/**
 * Gets all request for proposals
 */
export const useGetRequestForProposals = (props: UseGetRequestForProposalsProps) =>
  useGet<RequestForProposalsResponse, unknown, GetRequestForProposalsQueryParams, void>(
    `/v9/request_for_proposals`,
    props
  )

export interface UpdateRequestForProposalPathParams {
  /**
   * RFP ID
   */
  id: number
}

export interface UpdateRequestForProposalRequestBody {
  requestForProposal?: {
    salesforceRfpId?: string
    shipperApplicationId?: number
    requestForProposalType?: string
  }
}

export type UpdateRequestForProposalProps = Omit<
  MutateProps<
    void,
    void,
    void,
    UpdateRequestForProposalRequestBody,
    UpdateRequestForProposalPathParams
  >,
  'path' | 'verb'
> &
  UpdateRequestForProposalPathParams

/**
 * Update an existing Request for Proposal
 */
export const UpdateRequestForProposal = ({ id, ...props }: UpdateRequestForProposalProps) => (
  <Mutate<void, void, void, UpdateRequestForProposalRequestBody, UpdateRequestForProposalPathParams>
    verb='PUT'
    path={`/v9/request_for_proposals/${id}`}
    {...props}
  />
)

export type UseUpdateRequestForProposalProps = Omit<
  UseMutateProps<
    void,
    void,
    void,
    UpdateRequestForProposalRequestBody,
    UpdateRequestForProposalPathParams
  >,
  'path' | 'verb'
> &
  UpdateRequestForProposalPathParams

/**
 * Update an existing Request for Proposal
 */
export const useUpdateRequestForProposal = ({ id, ...props }: UseUpdateRequestForProposalProps) =>
  useMutate<
    void,
    void,
    void,
    UpdateRequestForProposalRequestBody,
    UpdateRequestForProposalPathParams
  >(
    'PUT',
    (paramsInPath: UpdateRequestForProposalPathParams) =>
      `/v9/request_for_proposals/${paramsInPath.id}`,
    { pathParams: { id }, ...props }
  )

export type DeleteRequestForProposalProps = Omit<
  MutateProps<void, ClientError, void, number, void>,
  'path' | 'verb'
>

/**
 * Deletes an existing Request For Proposal
 */
export const DeleteRequestForProposal = (props: DeleteRequestForProposalProps) => (
  <Mutate<void, ClientError, void, number, void>
    verb='DELETE'
    path='/v9/request_for_proposals'
    {...props}
  />
)

export type UseDeleteRequestForProposalProps = Omit<
  UseMutateProps<void, ClientError, void, number, void>,
  'path' | 'verb'
>

/**
 * Deletes an existing Request For Proposal
 */
export const useDeleteRequestForProposal = (props: UseDeleteRequestForProposalProps) =>
  useMutate<void, ClientError, void, number, void>('DELETE', `/v9/request_for_proposals`, {
    ...props,
  })

export type GetWorkStatusResponse = {
  total?: number | null
  pending?: number | null
  success?: number | null
  failure?: number | null
  error?: number | null
}

export interface GetWorkStatusQueryParams {
  /**
   * RFP ID
   */
  id: number
}

export type GetWorkStatusProps = Omit<
  GetProps<
    GetWorkStatusResponse,
    {
      errors?: string[]
    },
    GetWorkStatusQueryParams,
    void
  >,
  'path'
>

/**
 * Get work status
 */
export const GetWorkStatus = (props: GetWorkStatusProps) => (
  <Get<
    GetWorkStatusResponse,
    {
      errors?: string[]
    },
    GetWorkStatusQueryParams,
    void
  >
    path='/v9/request_for_proposals/work_status'
    {...props}
  />
)

export type UseGetWorkStatusProps = Omit<
  UseGetProps<
    GetWorkStatusResponse,
    {
      errors?: string[]
    },
    GetWorkStatusQueryParams,
    void
  >,
  'path'
>

/**
 * Get work status
 */
export const useGetWorkStatus = (props: UseGetWorkStatusProps) =>
  useGet<
    GetWorkStatusResponse,
    {
      errors?: string[]
    },
    GetWorkStatusQueryParams,
    void
  >(`/v9/request_for_proposals/work_status`, props)
